// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { equipmentModelId } from './EquipmentModel';
import { fermentationDashboardRevisionId } from './FermentationDashboardRevision';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationDashboard = z.object({
    id: z.number(),
    name: z.string(),
    equipment_model_id: equipmentModelId.nullable(),
    current_revision_id: fermentationDashboardRevisionId.nullable(),
    copied_from_revision_id: fermentationDashboardRevisionId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const fermentationDashboardInitializer = z.object({
    id: z.number().optional(),
    name: z.string(),
    equipment_model_id: equipmentModelId.optional().nullable(),
    current_revision_id: fermentationDashboardRevisionId.optional().nullable(),
    copied_from_revision_id: fermentationDashboardRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const fermentationDashboardMutator = z.object({
    id: z.number().optional(),
    name: z.string().optional(),
    equipment_model_id: equipmentModelId.optional().nullable(),
    current_revision_id: fermentationDashboardRevisionId.optional().nullable(),
    copied_from_revision_id: fermentationDashboardRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const fermentationDashboardId = z.number().int().positive();
//# sourceMappingURL=FermentationDashboard.js.map